<h4 *ngIf="isBookingSummary" [innerHTML]="'booking.bookingSummary.courses' | translate"></h4>
<section class="background-color-darkorange error" *ngIf="showServerError$ | async">
    <div class="container">
        <span class="error-message" [innerHTML]="'courses.serverError' | translate"></span>
        <button class="drg-icon-close" (click)="closeError()"></button>
    </div>
</section>
<section *ngIf="events$ | async as events" class="first-section">
    <ng-container *ngIf="events.length > 0 && !(showLoader$ | async); else loader">
        <table class="items">
            <tr class="header" *ngIf="events.length > 0">
                <th></th>
                <th class="title" [innerHTML]="'booking.booking.title' | translate"></th>
                <th [innerHTML]="'booking.booking.type' | translate"></th>
                <th [innerHTML]="'booking.booking.date' | translate"></th>
                <th [innerHTML]="'common.location' | translate"></th>
                <th colspan="2" class="price" [innerHTML]="'booking.booking.price' | translate"></th>
            </tr>
            <ng-container *ngIf="isLoggedInUser$ | async">
                <tr
                    *ngFor="let event of events; let i = index"
                    id="row{{ i }}"
                    [ngClass]="showWarningTile && checkPrerequirements(event, i) && !isBookingSummary ? 'warning' : ''"
                >
                    <!-- <tr *ngFor="let event of events; let i = index"> -->

                    <td class="order-number">
                        <span>{{ i + 1 }}.</span>
                        <div class="warning" *ngIf="!isBookingSummary">
                            <div class="inner">
                                <p [innerHTML]="'booking.booking.warning' | translate"></p>
                                <a class="close" (click)="closeWarning(event.externalId, event.courseId, i)"></a>
                            </div>
                        </div>
                    </td>
                    <td class="title">
                        <span class="order-number">{{ i + 1 }}.</span>

                        <a *ngIf="event.courseUnicodeTitle && event.courseUnicodeTitle !== null && event.courseUnicodeTitle !== ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseUnicodeTitle }}</a>
                        <a *ngIf="!event.courseUnicodeTitle || event.courseUnicodeTitle === null || event.courseUnicodeTitle === ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseName }}</a>
                    </td>
                    <td class="type">
                        <span *ngIf="event.courseType === 'WBT' && !event.isWishItem" [innerHTML]="'courses.online' | translate"></span>
                        <span *ngIf="(event.courseType === 'SEM' || event.courseType === 'WRK') && !event.isWishItem" [innerHTML]="'courses.presence' | translate"></span>
                        <span *ngIf="event.courseType === 'WBN' && !event.isWishItem" [innerHTML]="'courses.virtual' | translate"></span>
                        <span *ngIf="event.isWishItem" [innerHTML]="'courses.wishlist' | translate"></span>
                    </td>

                    <td class="date">
                        <span [innerHTML]="'booking.checkoutList.date' | translate"></span>
                        {{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}<span class="separator" *ngIf="event.beginDateTime"> -</span
                        ><br *ngIf="event.beginDateTime" />{{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}
                        <span *ngIf="!event.beginDateTime" class="line">-</span>
                    </td>
                    <td class="location">
                        <span [innerHTML]="'common.location' | translate"></span>
                        <span *ngIf="event.location">
                            <a class="city" (click)="openLocationOverlay(event)">{{ event.location.city }}</a>
                        </span>
                        <span *ngIf="!event.location" class="line">-</span>
                    </td>
                    <td class="price" *ngIf="!event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <!--            <div class="inner-content" *ngIf="order$ | async as order">-->
                            <span [innerHTML]="'booking.checkoutList.lastPrice' | translate"></span>
                            <p>
                                <span [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''">
                                    <i>{{ order.participants.length }} x </i>
                                </span>
                                    <da-checkout-list-event-price *ngIf="!(isLoggedInUser$ | async)" [price] = "event.externalPrice" [currency] = "currency"></da-checkout-list-event-price>
                                    <da-checkout-list-event-price *ngIf="(isLoggedInUser$ | async) && event.externalPrice !== null" [price] = "event.externalPrice" [currency] = "currency"></da-checkout-list-event-price>
                                    <da-checkout-list-event-price *ngIf="(isLoggedInUser$ | async) && event.externalPrice === null" [price] = "event.coursePrice" [currency] = "currency"></da-checkout-list-event-price>
                                
                            </p>
                        </ng-container>
                    </td>
                    <td class="price" *ngIf="event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <p>
                                <span
                                    class="headline"
                                    [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''"
                                >
                                    <i>{{ order.participants.length }} x </i> </span
                                ><span class="headline" [innerHTML]="'courses.prebooking' | translate"></span>
                            </p>
                        </ng-container>
                    </td>
                    <td class="delete">
                        <a href="" (click)="remove(i, $event)" class="link drg-icon-delete"></a>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="!(isLoggedInUser$ | async)">
                <tr *ngFor="let event of events; let i = index">
                    <td class="order-number">
                        {{ i + 1 }}.
                        <div class="warning" *ngIf="!isBookingSummary">
                            <div class="inner">
                                <p [innerHTML]="'booking.booking.warning' | translate"></p>
                                <a class="close" href="javascript:;"></a>
                            </div>
                        </div>
                    </td>
                    <td class="title">
                        <span class="order-number">{{ i + 1 }}.</span>
                        <a *ngIf="event.courseUnicodeTitle && event.courseUnicodeTitle !== null && event.courseUnicodeTitle !== ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseUnicodeTitle }}</a>
                        <a *ngIf="!event.courseUnicodeTitle || event.courseUnicodeTitle === null || event.courseUnicodeTitle === ''" class="title" [href]="getCourseDetailLink(event.courseId)">{{ event.courseName }}</a>
                    </td>
                    <td class="type">
                        <span *ngIf="event.courseType === 'WBT' && !event.isWishItem" [innerHTML]="'courses.online' | translate"></span>
                        <span *ngIf="(event.courseType === 'SEM' || event.courseType === 'WRK') && !event.isWishItem" [innerHTML]="'courses.presence' | translate"></span>
                        <span *ngIf="event.courseType === 'WBN' && !event.isWishItem" [innerHTML]="'courses.virtual' | translate"></span>
                        <span *ngIf="event.isWishItem" [innerHTML]="'courses.wishlist' | translate"></span>
                    </td>

                    <td class="date">
                        <span [innerHTML]="'booking.checkoutList.date' | translate"></span>
                        {{ event.beginDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}<span class="separator" *ngIf="event.beginDateTime"> -</span
                        ><br *ngIf="event.beginDateTime" />{{ event.endDateTime | date: (dateFormat$ | async) + ', ' + 'HH:mm' }}
                        <span *ngIf="!event.beginDateTime" class="line">-</span>
                    </td>
                    <td class="location">
                        <span [innerHTML]="'common.location' | translate"></span
                        ><span *ngIf="event.location">
                            <a class="city" (click)="openLocationOverlay(event)">{{ event.location.city }}</a>
                        </span>
                        <span *ngIf="!event.location" class="line">-</span>
                    </td>
                    <td class="price" *ngIf="!event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <!--            <div class="inner-content" *ngIf="order$ | async as order">-->
                            <span [innerHTML]="'booking.checkoutList.lastPrice' | translate"></span>
                            <p>
                                <span [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''">
                                    <i>{{ order.participants.length }} x </i>
                                </span>
                                    <da-checkout-list-event-price *ngIf="event.externalPrice" [price] = "event.externalPrice" [currency] = "currency"></da-checkout-list-event-price>
                                    <da-checkout-list-event-price *ngIf="!event.externalPrice" [price] = "event.coursePrice" [currency] = "currency"></da-checkout-list-event-price>


                            </p>
                            <!--            </div>-->

                            <!--          // todo: check if this is needed at all-->
                            <!--            <div class="desc">-->
                            <!--                {{ event.provider }}-->
                            <!--            </div>-->
                        </ng-container>
                    </td>
                    <td class="price" *ngIf="event.isWishItem">
                        <ng-container *ngIf="order$ | async as order">
                            <p>
                                <span
                                    class="headline"
                                    [ngClass]="order && order.participants && order.participants.length === 1 ? 'hide' : ''"
                                >
                                    <i>{{ order.participants.length }} x </i> </span
                                ><span class="headline" [innerHTML]="'courses.prebooking' | translate"></span>
                            </p>
                        </ng-container>
                    </td>
                    <td class="delete">
                        <a href="" (click)="remove(i, $event)" class="link drg-icon-delete"></a>
                    </td>
                </tr>
            </ng-container>
        </table>
    </ng-container>
    <section class="background-color-nearwhite bottom" *ngIf="isBookingSummary">
        <ng-container *ngIf="(isLoggedInUser$ | async) && (onlyWebinars$ | async) && (site === 'de_ch' || site === 'fr_ch' || site === 'ch-ext-md' || site === 'ch-ext-sd')">
            <da-coupon-code (voucherData)="findNewAmount($event)" [totalPrice]="totalPrice$ | async" [minusPrice]="minusPrice$ | async" [currency]="currency"></da-coupon-code>
        </ng-container>
        <div  *ngIf="!(onlyWishListItems$ | async)" class="bottom-wrapper">
            <table class="summary">
                <tr class="total">
                    <td><span [innerHTML]="'booking.booking.total' | translate"></span></td>
                    <td>
                        <span class="price">
                            <span>
                                <span> {{ formattedTotalPrice$ | async }}</span>
                                <span [innerHTML]="'booking.checkoutList.priceDesc' | translate"></span>
                            </span>
                        </span>
                    </td>
                </tr>
            </table>
        </div>
    </section>
    <!-- <section class="background-color-white bottom" *ngIf="!isBookingSummary && !(showServerError$ | async)"> -->
    <section class="background-color-white bottom" *ngIf="!isBookingSummary && !(showLoader$ | async)">
        <ng-container *ngIf="requiredQualificationsList$ | async as requiredQualificationsList">  
            <div class="requirement-container" *ngFor="let item of requiredQualificationsList">
                <div class="requirement-icon">
                    <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M40.976 34.4065L36.789 30.1915V18.5025H25.0435L20.885 14.3155H29.8715V10.187C29.8715 8.51467 29.2769 7.09667 28.0875 5.933C26.8979 4.769 25.4622 4.187 23.7805 4.187C22.0815 4.187 20.648 4.76233 19.48 5.913C18.3124 7.06367 17.7285 8.47183 17.7285 10.1375V11.1025L14.239 7.6695C14.6434 5.41583 15.7269 3.57416 17.4895 2.1445C19.2519 0.714831 21.3554 0 23.8 0C26.62 0 29.03 0.985832 31.03 2.9575C33.0304 4.9295 34.0305 7.3205 34.0305 10.1305V14.3155H36.789C37.9124 14.3155 38.891 14.7258 39.725 15.5465C40.559 16.3675 40.976 17.3528 40.976 18.5025V34.4065ZM43.952 48.409L38.8025 43.3415C38.5575 43.4935 38.267 43.6265 37.931 43.7405C37.5954 43.8542 37.2147 43.911 36.789 43.911H11.211C10.0957 43.911 9.1237 43.4983 8.29503 42.673C7.46636 41.8477 7.05203 40.874 7.05203 39.752V18.5025C7.05203 17.4685 7.37886 16.5965 8.03253 15.8865C8.6862 15.1768 9.38253 14.7575 10.1215 14.6285L-0.730469 3.7545L1.75653 1.261L46.411 45.972L43.952 48.409ZM35.3175 39.752L26.8805 31.337C26.5182 31.6993 26.0982 31.9758 25.6205 32.1665C25.1429 32.3568 24.6484 32.452 24.137 32.452C23.04 32.452 22.1234 32.0907 21.387 31.368C20.6507 30.645 20.2825 29.7462 20.2825 28.6715C20.2825 28.1182 20.3779 27.5962 20.5685 27.1055C20.7592 26.6148 21.0357 26.1978 21.398 25.8545L14.0175 18.5025H11.211V39.752H35.3175Z" fill="#1C1B1F"/>
                    </svg>
                </div>
                <div class="required-qualifications-text">
                    <p *ngIf="item.rqCourses.length > 0">
                        <span [innerHTML]="item.requiredQualificationsText[0]"></span>
                        <a (click)="openRequiredQualificationsModal(item.courseId)">
                            <strong><span [innerHTML]="'booking.checkoutList.requiredQualificationsLink' | translate"></span></strong>
                            <i></i>
                        </a> 
                        <span [innerHTML]="item.requiredQualificationsText[1]"></span>
                    </p>
                    <p *ngIf="item.rqCourses.length === 0">
                        <span [innerHTML]="item.requiredQualificationsNoCourseText"></span>
                    </p>
                </div>
            </div>
        </ng-container>
        <div>
            <ng-container *ngIf="order$ | async as order">
                <div class="participants" *ngIf="order && order.participants">
                    <p class="text" [innerHTML]="'booking.booking.info' | translate"></p>
                    <p>
                        <a
                            [ngClass]="order && order.participants && order.participants.length > 1 ? '' : 'disabled'"
                            class="decrease"
                            (click)="decreaseParticipants()"
                        ></a>
                        <span>{{ order.participants.length }}</span>
                    </p>

                    <a
                        class="increase"
                        [ngClass]="order && order.participants && order.participants.length === (maxSeats$ | async) ? 'disabled' : ''"
                        (click)="increaseParticipants()"
                    ></a>
                </div>
                <div
                    class="error"
                    *ngIf="order && order.participants && order.participants.length === (maxSeats$ | async)"
                    [innerHTML]="'booking.bookingParticipants.error' | translate"
                ></div>
            </ng-container>
            <div class="bottom-wrapper">
                <table class="summary">
                    <tr class="total" *ngIf="!(onlyWishListItems$ | async)">
                        <td><span [innerHTML]="'booking.booking.total' | translate"></span></td>
                        <td>
                            <span class="price">
                                <span class="totalPrice">{{ formattedTotalPrice$ | async }}</span>
                                <span [innerHTML]="'booking.checkoutList.priceDesc' | translate"></span>
                            </span>
                        </td>
                    </tr>
                   <tr *ngIf="!isBookingSummary && (onlyWebinars$ | async) && (isLoggedInUser$ | async) && (site === 'de_ch' || site === 'fr_ch' || site === 'ch-ext-md' || site === 'ch-ext-sd')">
                        <td class="voucher-info">
                            <p class="coupon-code-info" [innerHTML]="'couponCode.couponCodeInfo' | translate"></p>
                        </td>
                    </tr>
                    <tr class="button-wrapper" *ngIf="events$ | async as events">
                        <td class="back">
                            <a
                                da-link
                                [routerLink]="getCoursesLink()"
                                class="button secondary"
                                [innerHTML]="'booking.booking.backToCourses' | translate"
                            >
                            </a>
                        </td>
                        <td class="next">
                            <button 
                                *ngIf="events.length > 0"
                                [disabled]="(requiredQualificationsList$ | async).length > 0"
                                (click)="nextClick()" 
                                class="button primary">
                                <span [innerHTML]="'booking.booking.toTheBooking' | translate"></span>
                            </button>                            
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </section>
</section>

<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warning"></ng-container>
    </div>
</ng-template>
<ng-template #warning>
    <div class="warn-popup">
        <div class="inner-wrapper">
            <div class="details" *ngIf="order$ | async as order">
                <h3 *ngIf="order.requestCreated" [innerHTML]="'booking.checkoutList.deleteCourseTitle' | translate"></h3>
                <h3 *ngIf="!order.requestCreated" [innerHTML]="'booking.checkoutList.emptyCartTitle' | translate"></h3>
                <p *ngIf="order.requestCreated" [innerHTML]="'booking.checkoutList.deleteCourseText' | translate"></p>
                <p *ngIf="!order.requestCreated" [innerHTML]="'booking.checkoutList.empyCart' | translate"></p>
                <div class="button-wrapper">
                    <a
                        (click)="cancleOrder()"
                        class="button secondary"
                        [innerHTML]="'booking.checkoutList.deleteCourseBtn' | translate"
                    ></a>
                    <a (click)="cancle()" class="button primary" [innerHTML]="'booking.checkoutList.cancleDeleteCourse' | translate"></a>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #locationOverlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="location"></ng-container>
    </div>
</ng-template>
<ng-template #location>
    <div class="location-popup" *ngIf="location$ | async as event">
        <div class="title">
            <span [innerHTML]="'common.location' | translate"></span>
        </div>
        <div class="details">
            <span><strong [innerHTML]="'common.address' | translate"></strong></span>
            <span>{{ event.location.name }}</span>
            <span>{{ event.location.street }}</span>
            <span>{{ event.location.city }} {{ event.location.zip }} </span>
            <span>{{ event.location.regionKey }}</span>
            <span>{{ countryName }} ({{ event.location.countryKey }})</span>
            <a
                *ngIf="event.location.isMapAvailable"
                target="_blank"
                [href]="envApi + 'api/v1/course/getlocationmap/' + event.location.locationSign"
                ><span [innerHTML]="'common.downloadRoute' | translate"></span
            ></a>
            <div><a class="button primary" [innerHTML]="'common.close' | translate" (click)="closeModal()"></a></div>
        </div>
    </div>
</ng-template>

<ng-template #requiredQualificationsModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <h3 [innerHTML]="'courses.requiredQualifications.modal.title' | translate"></h3>
                <p [innerHTML]="'courses.requiredQualifications.modal.intro' | translate"></p>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a class="button secondary" da-link (click)="goToContact()" [innerHTML]="'courses.requiredQualifications.modal.contactButton' | translate"></a>
                        <a
                            class="button primary"
                            da-link
                            (click)="goToCourseDetails('prerequisites')"
                            [innerHTML]="'courses.requiredQualifications.modal.detailButton' | translate"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>